import { createReducer } from '@reduxjs/toolkit';
import { getPoints, getPointsPrice } from '../actions/points';

const initialState = {
  points: 0,
  loading: true,
  data: [],
  price: 0,
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getPoints.fulfilled, (state, action) => ({
    ...state,
    points: action.payload.total || 0,
    loading: false,
    data: action.payload.points,
  })).addCase(getPointsPrice.fulfilled, (state, action) => ({
    ...state,
    price: action.payload.price,
  }));
});
